import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * `<nb-side-brand>` — the sidebar brand header (Mockup `web.css .side-brand`).
 *
 * Shows the lag mark (a rounded square initial), the lag name (`.nm`) and an
 * uppercase sub-line (`.sb`). Inside a `.sidebar.admin` column the text and mark
 * flip to the dark-variant colours automatically.
 *
 * @example <nb-side-brand name="Solsiden" sub="Borettslag" mark="S" />
 */
@Component({
  selector: 'nb-side-brand',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'side-brand' },
  template: `<div class="lagmark" aria-hidden="true">{{ mark() }}</div>
    <div>
      <div class="nm">{{ name() }}</div>
      @if (sub()) {
        <div class="sb">{{ sub() }}</div>
      }
    </div>`,
  styleUrl: './side-brand.css',
})
export class NbSideBrand {
  /** Lag display name (the `.nm` line). */
  readonly name = input.required<string>();
  /** Uppercase sub-line under the name (the `.sb` line). Optional. */
  readonly sub = input<string>('');
  /** Single character / short initials shown in the lag mark. */
  readonly mark = input<string>('');
}
